;(function ($, window, document, undefined) {
    'use strict';

    var UserBadges = function (element, options) {
        this.opts      = options;
        this.els       = options.els;
        this.els.$list = $('#list');
        //this.users     = 0;
        //this.l10n      = $.parseJSON( this.els.$boardsList.find( '.l10n-content' ).html() );

        this.init();
    };

    UserBadges.prototype = {

        init : function () {
            //this.totalUsers();
            this.layout();
        },

        totalUsers : function () {
            var that = this;
            var date = new Date();
            var _key = date.getDay() + '-' + date.getMonth() + '-' + date.getYear();
            var key  = 'api.users.total.' + _key;
            var total = store.get(key);

            if (!total) {
                $.ajax({
                    type : 'GET',
                    url  : '/restapi/vc/users/count',
                    data : {
                        'restapi.response_style'  : 'view',
                        'restapi.response_format' : 'json'
                    },
                    success : function (response) {
                        that.users = response.response.value.$;
                        store.set(key, that.users);
                        that.layout();
                    }
                });
            }
            else {
                this.users = total;
                this.layout();
            }
        },

        layout : function () {
            var that = this,
                touch = this.els.$html.hasClass('touch-device');

            this.els.$list.find( 'li' ).each( function () {
                var $desc = $(this).find('.lia-user-badge-description');
                var earnedByCopy = $(this).find('.lia-badge-participants-count').text();
                var earnedBy = $(this).find('.lia-badge-participants-count').text().replace(',', '').replace('.', '').match(/\d+/g)[0];
                //var percentage = ( earnedBy * 100 ) / that.users;
                var percentage = 25;
                var stars = 3;
                var type = 'Rare';
                var stats = '';

                if (touch) {
                    $(this).addClass('touch');
                    var $close = $('<div class="close-popup"><span class="icon"><svg id="${id}" class="${class}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="48.062" height="36" viewBox="0 0 24.031 18"><path d="M20.011,16.429 L16.438,20.002 L10.007,13.571 L3.575,20.002 L0.002,16.429 L6.434,9.998 L0.002,3.566 L3.575,-0.007 L10.007,6.424 L16.438,-0.007 L20.011,3.566 L13.580,9.998 L20.011,16.429 Z" class="cls-1"/></svg></span></div>');
                    $desc.append($close);

                    $(this).click(function() {
                        $(this).toggleClass('active').siblings().removeClass('active');
                    } );

                    // $desc.find('.close-popup').on('click', function (e) {
                    //     e.preventDefault();
                    //     $(this).closest('li').removeClass('active');
                    // });
                }

                if(earnedBy < 1000) {
                    stars = 3;
                    type = pageData.localisation.badges_very_rare;
                    stats = Math.floor(percentage) + pageData.localisation.users_have_this;
                }
                else if (earnedBy >= 1000 && earnedBy < 10000 ) {
                    stars = 2;
                    type = pageData.localisation.badges_rare;
                    stats = pageData.localisation.badges_over.replace('{0}', Math.floor(percentage) + '%');
                }
                else if (earnedBy >= 10000) {
                    stars = 1;
                    type = pageData.localisation.badges_common;
                    stats = pageData.localisation.badges_over.replace('{0}', Math.floor(percentage) + '%');
                }

                stats = earnedByCopy;

                $desc.find('div').addClass('desc');

                if ( !$( this ).find( '.lia-badge-not-achieved' ).size() ) {
                    var date = $(this).find('.lia-user-badge-date').text();
                    $desc.append('<div class="date">' + pageData.localisation.badges_earned + ' ' + date + '</div>');
                }

                var $rare = $('<div class="rare" />');

                $('<div class="stars"/>').html('<label>' + type + '</label><span class="rating rated-' + stars + '"></span>').appendTo($rare);
                $('<div class="stats"/>').html(stats).appendTo($rare);

                $desc.append($rare);
            });
        }

    };

    $.fn.UserBadges = function (options){

        var args     = Array.prototype.slice.call(arguments, 1),
            $item    = $(this),
            instance = $item.data( 'UserBadges' );

        if (!instance) {
            instance = new UserBadges(this, options);
            $item.data('UserBadges', instance);
        }

        if (typeof options === 'string') {
            instance[options].apply(instance, args);
        }

        return this;
    };

})(jQuery, window, document);
